import { createAction } from 'redux-act';

export const setData = createAction('order set data');
export const failGetData = createAction('order fail get data');
export const successGetData = createAction('order success get data');

export const getPromotion = createAction('order get promotion');
export const getCourse = createAction('order get course');
export const putOrder = createAction('order put order');
export const putItemOrder = createAction('order put item order');

export const checkEmail = createAction('check email');
export const successCheckEmail = createAction('success check email');
export const failCheckEmail = createAction('fail check email');

export const checkUser = createAction('check user');
export const successCheckUser = createAction('success check user');
export const failCheckUser = createAction('fail check user');



// WEBPACK FOOTER //
// ./src/actions/order.js